<template lang="pug">
  .container.grid-lg
    page-title(title="Acessos" icon="fas fa-mouse-pointer" subtitle="Acessos que fizeram utilizando seu código de afiliado")
      div(slot="actions")
        router-link.btn.btn-link.tooltip.tooltip-left.mr-2(
          :to="{ name: 'filiationAccess.list.filter', query: $route.query }"
          data-tooltip="Filtrar"
        )
          i.fas.fa-filter
          span.badge(v-if="Boolean($route.query.q)")
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      .table-responsive(v-if="list && list.rows.length > 0")
        table.table.table-responsive.table-hover.table-striped
          thead
            tr
              th Nome Usuário
              th.text-right Acesso em
          tbody
            tr(v-for="row in list.rows")
              td
                span(v-if="row.person")
                  user-avatar.mr-2.avatar-sm(:user="row.person")
                  | {{row.person.fullName}}
                cite(v-else) Acesso não logado
              td.text-right {{ row.createdAt | date('DD/MM/YYYY HH:mm') }}
    router-view
</template>

<script>
import listMixin from '@/mixins/list'
import filiationAccess from '@/services/api/filiationAccess'

export default {
  mixins: [listMixin],
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await filiationAccess.list(params)
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
